import React, { useCallback, useLayoutEffect, useRef, useState } from 'react'

import { useWindowResize } from '../../hooks/useWindowResize'
import { Icon } from '../Icon'
import Button from '../app/design/Button'

type Props = {
    children: React.ReactNode
    deps?: any[]
    scrollAmount?: number
    scrollRefs?: React.RefObject<HTMLElement>[]
    style?: {
        wrapper?: React.CSSProperties
        overflow?: React.CSSProperties
        leftControl?: React.CSSProperties
        rightControl?: React.CSSProperties
    }
}

export const CalendarScrollX = ({
    children,
    deps,
    scrollAmount = 250,
    scrollRefs = [],
    style = {},
}: Props) => {
    const { width } = useWindowResize()
    const wrapperRef = useRef<HTMLDivElement>(null)
    const [overflow, setOverflow] = useState(false)

    useLayoutEffect(() => {
        if (!wrapperRef.current) return
        setOverflow(wrapperRef.current.scrollWidth > wrapperRef.current.clientWidth)
    }, [width, deps])

    const scroll = useCallback(
        (direction: 1 | -1 = 1) => {
            ;[wrapperRef, ...scrollRefs].forEach((ref) => {
                if (!ref.current) return

                ref.current.scrollBy({
                    left: scrollAmount * direction,
                    behavior: !scrollRefs.length ? 'smooth' : 'auto',
                })
            })
        },
        [scrollRefs, scrollAmount]
    )

    return (
        <div className="relative h-full w-full min-w-0">
            <div
                className="scrollbar-hide flex overflow-x-scroll"
                style={overflow ? { ...style.wrapper, ...style.overflow } : style.wrapper}
                ref={wrapperRef}
            >
                {children}
            </div>
            {overflow && (
                <>
                    <Button
                        shape="circle"
                        size="small"
                        className="absolute top-[calc(50%-18px)] shadow-lg"
                        style={style.leftControl}
                        onClick={() => scroll(-1)}
                    >
                        <Icon icon="chevronLeft.small" />
                    </Button>

                    <Button
                        shape="circle"
                        size="small"
                        className="absolute top-[calc(50%-18px)] right-0 shadow-lg"
                        style={style.rightControl}
                        onClick={() => scroll(1)}
                    >
                        <Icon icon="chevronRight.small" />
                    </Button>
                </>
            )}
        </div>
    )
}
